// Site settings; each can be set at build time with an environment variable.
const env = import.meta.env;

/** The open-source package's repository. */
export const GITHUB_URL: string = env.VITE_GITHUB_URL || 'https://github.com/HendrikK/wobbli-avatar';
export const SITE_URL = 'https://wobbli.dev/';
/** Where share links open: this site (wobbli.dev in production). */
export const SHARE_BASE: string = env.VITE_SHARE_BASE || (typeof location !== 'undefined' ? location.origin + import.meta.env.BASE_URL : SITE_URL);
export const PACKAGE_NAME: string = env.VITE_PACKAGE_NAME || 'wobbli';
export const REGISTRY_URL: string = env.VITE_REGISTRY_URL || 'https://wobbli.dev/r/wobbli.json';
/** The contact form posts here (JSON: email, message, website). On wobbli.dev the contact Worker answers it (see contact/); an empty value makes the form say it cannot send yet. */
export const CONTACT_ENDPOINT: string = env.VITE_CONTACT_ENDPOINT ?? '/api/contact';
/** Wobbli's colour: the site's avatar wears it until a visitor picks another or changes the name. */
export const SITE_COLOR = '#C6E360';
export const BLOBATAR_URL = 'https://github.com/Alain00/blobatar';
